<template>

    

</template>

<script>
import axios from 'axios';
 
export default {
    name: 'HomeDivTiles',
    data() {
        return {
            new_data: [],
            newShow:false,
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN,
            interactive_block: []
        };
                
    },
    computed:{
        languageData(){return this.$store.state.languageData;}
    },
    components: {
           
        },
    created :function(){        
        
        this.showInteractiveBlock();      
    },
    methods:{
        showInteractiveBlock(){ 
            //console.log('testlogic-'+this.$store.state.themeLogic['headers']['announcement']);
            var api_private_key=this.get_api_key_mix('inck')
            axios.get(this.$store.state.apiUrl+'/interactive_block',{
                params:{
                    id_language:this.$store.state.companyData['id_language'],
                    id_company:this.$store.state.companyData['id_company'],
                    id_country:this.$store.state.companyData['id_country'],  
                    privatekey:api_private_key 
                }
                })
            .then(response => {
                response = response.data
                this.interactive_block = response;
                
            })
            .catch((error) => {
                this.interactive_block = [];
                this.customErrorHandler(error.response.status);
            });
        }

    }
}
</script>
<style scoped>
.blog-entry .desc {
    background: #2f2f2fcc !important;
}
.blog-entry .side{
    margin-bottom: 0;
}
.category li a {
    border-bottom: 1px solid #c5c5c599 !important;
    display: block;
    padding: 5px 0;
    color: #e6e6e6 !important;   
}
.category li {
    list-style: none !important;
}
.head-article{
    color: #fff !important;
}
.btn-style{
    display: inline-block;
    bordeR: 1px solid rgba(255, 255, 255, 0.5);
    padding: 3px 11px;
    -webkit-border-radius: 16px;
    -moz-border-radius: 16px;
    -ms-border-radius: 16px;
    border-radius: 16px;
    color: #fcfcfc;
    background: #505050ed;
    font-size: 12px;
}
.btn-style:hover{
    border: 1px solid rgba(255, 255, 255, 0.82);
    color: #fff;
}
.category li a:hover,.category li a:focus {
    color: #fff !important;
}

.content-height{
    overflow: auto !important;
    max-height: 355px !important;
}
@media only screen and (max-width: 768px) {
    .content-height{
        max-height: 255px !important;
    }
}
    
</style>